export const isCustomExpand = (expandable = {}) => {
  const { rowExpandable, expandedRowRender } = expandable;

  return typeof rowExpandable === 'function' && typeof expandedRowRender === 'function';
};
